import type { ComponentProps, ReactNode } from 'react';

export interface AnchorProps extends ComponentProps<'a'> {
  disabled?: boolean;
  children?: NonNullable<ReactNode>;
}

export function Anchor({ disabled, children, target, ...props }: AnchorProps): ReactNode {
  return (
    <a rel={target ? 'noopener noreferrer' : undefined} target={target} {...props}>
      {children}
    </a>
  );
}
